import React, { useEffect } from 'react';
import '../styles/LandingPage.css';
import '../styles/Slideshow.css';  // Add this import
import Slideshow from '../components/Slideshow';  

const LandingPage = () => {

    useEffect(() => {
    (function(d, w, c) {
      w.ChatraID = 'XsYGMCQ4ANZregsLE';
      var s = d.createElement('script');
      w[c] = w[c] || function() {
        (w[c].q = w[c].q || []).push(arguments);
      };
      s.async = true;
      s.src = 'https://call.chatra.io/chatra.js';
      if (d.head) d.head.appendChild(s);
    })(document, window, 'Chatra');
  }, []);

  
  // Define your slide data - using working placeholder services
  const heroSlides = [
    {
      image: "/images/Swimming.jpg",
      title: "Advanced Pumping Solutions for Every Industry",
      subtitle: "From residential to industrial applications, Pentair delivers reliable, efficient pumping systems that keep your operations flowing smoothly.",
      buttonText: "Explore Products",
      buttonLink: "/products"
    },
    {
      image: "/images/auroraendsuction2.png", 
      title: "Aurora End Suction Pumps",
      subtitle: "High-efficiency centrifugal pumps designed for commercial and industrial applications.",
      buttonText: "View Aurora Series",
      buttonLink: "/products"
    },
    {
      image: "/images/industrialseries.png",
      title: "Industrial Centrifugal Series",
      subtitle: "Robust pumps built for demanding industrial environments with superior reliability.",
      buttonText: "Find Your Pump",
      buttonLink: "https://pentair.intelliquip.com/Party/application/cookieconsent/openaccesslogin?afterConsentUrl=https%3A%2F%2Fpentair.intelliquip.com%2FIEQ_HydSel%2FHydSel_JSP%2FApp%2Fstart%3FselectionRefresh%3Dtrue%26entryType%3Dselector%26returnURL%3Dhttp%253A%252F%252Fwww.aurorapump.com%26UID%3D87d62feb377be201c1e35ed59d8d70b1%26quantityItems%3D1%26isRequestFromEntryServlet%3Dyes&UID=87d62feb377be201c1e35ed59d8d70b1"
    },
    {
      image: "https://images.unsplash.com/photo-1621905252507-b35492cc74b4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80",
      title: "Expert Service & Support",
      subtitle: "Professional maintenance and technical expertise when you need it most.",
      buttonText: "Schedule Service",
      buttonLink: "/contact"
    }
  ];

  return (
    <div className="landing-page">
      {/* Hero Slideshow - replaces the old hero section */}
      <Slideshow 
        slides={heroSlides}
        autoPlay={true}
        autoPlayInterval={6000}
        showIndicators={true}
        showArrows={true}
        height="75vh"  // Reduced from 100vh - try different values here
      />
      {/* Featured Products Section */}
      <section className="featured-products">
        <div className="container">
          <h2 className="section-title">Featured Products</h2>
          <p className="section-subtitle">
            Discover our most popular and innovative pumping solutions
          </p>

        <div className="featured-products-grid">
          <div className="featured-product-card">
            <div className="featured-product-image">
              <img 
                src="images/fairbanksnijhuisinline.png"
                alt="Fairbanks Nijhuis In Line"
                className="product-photo"
              />
            </div>
            <div className="featured-product-info">
              <h3 className="product-name">Fairbanks Vertical Inline Pump</h3>
              <p className="product-description">
                Vertical Inline Close Coupled Pumps are specifically designed for mounting, directly in a pipe line. 
              </p>
              <div className="featured-product-specs">
                <div className="spec-item">
                  <span className="spec-label">Starting Price:</span>
                  <span className="spec-value">$2,450</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Flow Rate:</span>
                  <span className="spec-value">Up to 12,000 GPM</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Lead Time:</span>
                  <span className="spec-value">2-3 weeks</span>
                </div>
              </div>
              <div className="product-actions">
                <a href="https://www.pentair.com/en-us/flow/fairbanks-nijhuis/fairbanks-products/fairbanks-end-suction-pumps/fairbanks-nijhuis-1600-series-single-stage-end-suction-pumps.html" className="btn-product">View Details</a>
                <a href="/contact" className="btn-outline">Get Quote</a>
              </div>
            </div>
          </div>
          <div className="featured-product-card featured">
            <div className="featured-badge">Best Seller</div>
            <div className="featured-product-image">
              <img 
                src="/images/auroraendsuction.png"
                alt="Industrial Centrifugal Pump"
                className="product-photo"
              />
            </div>
            <div className="featured-product-info">
              <h3 className="product-name">Aurora End Suction Pumps</h3>
              <p className="product-description">
                When it's time to move liquid from place to place, the Aurora 3800 Series is game. Provide efficient water transfer for HVAC systems, pressure boosting, and chilled water circulation.
              </p>
              <div className="featured-product-specs">
                <div className="spec-item">
                  <span className="spec-label">Starting Price:</span>
                  <span className="spec-value">$3,850</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Flow Rate:</span>
                  <span className="spec-value">Up to 5,000 GPM</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Lead Time:</span>
                  <span className="spec-value">3-4 weeks</span>
                </div>
              </div>
              <div className="product-actions">
                <a href="/products/aurora-end-suction" className="btn-product">View Details</a>
                <a href="/contact" className="btn-outline">Get Quote</a>
              </div>
            </div>
          </div>
          <div className="featured-product-card">
            <div className="featured-product-image">
              <img 
                src="/images/myersandhydromatic.png"
                alt="Submersible Solids Handling Pump"
                className="product-photo"
              />
            </div>
            <div className="featured-product-info">
              <h3 className="product-name">Myers Next-Gen Submersible Solids Handling Pump</h3>
              <p className="product-description">
                If you are facing enough pressure to maintain your wastewater systems and ensure they operate efficiently and continuously. Let Myers MNG Series Pumps take that pressure off your hands.
              </p>
              <div className="featured-product-specs">
                <div className="spec-item">
                  <span className="spec-label">Starting Price:</span>
                  <span className="spec-value">$1,850</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Flow Rate:</span>
                  <span className="spec-value">Up to 2,000 GPM</span>
                </div>
                <div className="spec-item">
                  <span className="spec-label">Lead Time:</span>
                  <span className="spec-value">1-2 weeks</span>
                </div>
              </div>
              <div className="product-actions">
                <a href="https://www.pentair.com/en-us/flow/hydromatic/hydromatic-products/hydromatic-commercial-products/hydromatic-solids-handling-pumps/hydromatic-hps-4hcx.html" className="btn-product">View Details</a>
                <a href="/contact" className="btn-outline">Get Quote</a>
              </div>
            </div>
          </div>
        </div>
        </div>
      </section>

      {/* Featured Events Section */}
      <section className="featured-events">
        <div className="container">
          <h2 className="section-title">Featured Events & News</h2>
          <p className="section-subtitle">
            Stay updated with our latest accomplishments, insights, and educational content
          </p>

          <div className="events-grid">
            <div className="event-card">
              <div className="event-type">Achievement</div>
              <div className="event-content">
                <h3 className="event-title">Pentair Named one of World's Greenest Companies</h3>
                <p className="event-description">
                  We are proud to share that our efforts to support a more sustainable future were recently recognized with Pentair being named one of the World’s Greenest Companies by Newsweek and Plant-A Insights Group in collaboration with GIST Impact. 
                </p>
                <div className="event-meta">
                  <span className="event-date">May 2025</span>
                  <a href="https://www.pentair.com/en-us/about-pentair/newsroom/blog/pentair-named-newsweek-worlds-greenest-companies-2025.html" className="event-link">Read More →</a>
                </div>
              </div>
            </div>

            <div className="event-card">
              <div className="event-type">Report</div>
              <div className="event-content">
                <h3 className="event-title">2024 Sustainability Report</h3>
                <p className="event-description">
                  Sustainability is at the core of our business. Keeping our commitment to environmental stewardship, we are excited to share our 2024 Sustainability Report.
                  Learn about our latest sustainability initiatives, including energy efficiency improvements and water conservation efforts across our operations.
                </p>
                <div className="event-meta">
                  <span className="event-date">December 2024</span>
                  <a href="https://www.pentair.com/content/dam/extranet/enterprise/digital/enterprise-pages/pentair-sustainability-report-2024.pdf" className="event-link">Read Report →</a>
                </div>
              </div>
            </div>

          <div className="event-card video-card">
            <div className="event-type">Video</div>
            <div className="video-container">
              <iframe 
                width="100%" 
                height="200" 
                src="https://www.youtube.com/embed/NyQ6Epbr6Qw" 
                title="Learn More About Power Penn 1 in NYC"
                frameBorder="0" 
                allowFullScreen
              ></iframe>
            </div>
            <div className="event-content">
              <h3 className="event-title">Learn More About Power Penn 1 in NYC</h3>
              <p className="event-description">
              </p>
              <div className="event-meta">
                <span className="event-date">One Month Ago</span>
              </div>
            </div>
          </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Find Your Perfect Pump?</h2>
            <p className="cta-description">
              Use our advanced pump selector tool to find the ideal solution for your specific needs,
              or connect with our expert team for personalized recommendations.
            </p>
            <div className="cta-buttons">
              <a href="https://pentair.intelliquip.com/Party/application/cookieconsent/openaccesslogin?afterConsentUrl=https%3A%2F%2Fpentair.intelliquip.com%2FIEQ_HydSel%2FHydSel_JSP%2FApp%2Fstart%3FselectionRefresh%3Dtrue%26entryType%3Dselector%26returnURL%3Dhttp%253A%252F%252Fwww.aurorapump.com%26UID%3D87d62feb377be201c1e35ed59d8d70b1%26quantityItems%3D1%26isRequestFromEntryServlet%3Dyes&UID=87d62feb377be201c1e35ed59d8d70b1" className="btn-primary large">Use Pump Selector</a>
              <a href="/contact" className="btn-secondary large">Contact Expert</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;